import { getVideoEmbedUrl } from '@/lib/videoEmbed';

interface VideoPreviewProps {
  url: string;
}

const getEmbedUrl = getVideoEmbedUrl;

export function VideoPreview({ url }: VideoPreviewProps) {
  const embedUrl = getEmbedUrl(url);

  if (!embedUrl) {
    return (
      <div className="flex items-center justify-center rounded-lg border-2 border-dashed border-neutral-300 bg-neutral-50 p-8">
        <div className="text-center">
          <svg className="mx-auto h-10 w-10 text-neutral-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z" />
          </svg>
          <p className="mt-2 text-sm text-neutral-500">
            {url ? 'URL video non valido. Usa un link YouTube o Vimeo.' : 'Inserisci un URL YouTube o Vimeo per vedere l\'anteprima'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="aspect-video w-full overflow-hidden rounded-lg border border-neutral-200">
      <iframe
        src={embedUrl}
        title="Anteprima video"
        className="h-full w-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
